// extracted by mini-css-extract-plugin
export default {"insta":"_34UM6"};